<template>
  <v-app-bar :elevation="0" color="background">
    <v-container class="pa-0" fluid>
      <!-- espacio opcional para la búsqueda -->
    </v-container>

    <template v-slot:prepend>
      <v-btn v-if="isMobile" icon @click="toggleDrawer">
        <v-icon>mdi-menu-close</v-icon>
      </v-btn>
    </template>

    <template v-slot:append>
      <!--v-btn icon="mdi-forum">
        <v-badge color="error" content="2">
          <v-icon>mdi-forum</v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon="mdi-bell-outline">
        <v-badge color="error" content="2">
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn-->

      <v-chip link pill class="justify-space-between pr-0 pl-4" to="/profile">
        {{ user?.name + ' ' + user?.last_name || 'Guest' }}
        <v-avatar class="avatar-custom ml-3" color="primary">
          {{user?.name?.slice(0,1)}}
          <!--v-img :src="user.avatar || 'https://cdn.vuetifyjs.com/images/john.png'" /-->
        </v-avatar>
      </v-chip>
    </template>
  </v-app-bar>
</template>

<script setup>
import { useAuthStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';
import { useDisplay } from 'vuetify';
import { computed } from 'vue';

const authStore = useAuthStore();
const uiStore = useUiStore();
const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const user = computed(() => authStore.user || {});

const toggleDrawer = () => {
  uiStore.drawer = !uiStore.drawer;
};
</script>

<style scoped>
.avatar-custom {
  margin-left: 10px;
}
</style>
